import moment from "moment"

function installVueGlobal(Vue, globalName, globalValue) {
  const globalPrototype = Vue.version.slice(0, 2) === '3.' ? Vue.config.globalProperties : Vue.prototype;

  // Don't use Object.assign() to match the Vue.js supported browsers (ECMAScript 5)
  globalPrototype[globalName] = globalValue;
}

export function getDate(dateParam) {
  let date = null;
  if (dateParam) {
    date = moment.utc(dateParam).local();
  } else {
    date = moment.utc(new Date()).local();
  }
  return date
}

const dateUtils = {
  moment,
  toFormat(pdate, format) {
    let date = getDate(pdate);
    return date.format(format);
  },
  toDDMMYYYY(pdate) {
    let date = getDate(pdate);
    return date.format('L');
  },
  toDDMMYYYYHH(pdate) {
    let date = getDate(pdate);
    return date.format('L HH:mm');
  },
  toLongDate(pdate) {
    let date = getDate(pdate);
    return date.format('LLL');
  },
  toNoHourLongDate(pdate) {
    let date = getDate(pdate);
    return date.format('LL');
  },
  toDateInputValue(pdate) {
    if (!pdate) return '';
    return moment.utc(pdate).format('YYYY-MM-DD');
  },
  // A lot date is a calendar date, so it is read without timezone conversion,
  // and only in the formats it may be stored in; anything else returns ''
  // instead of a guessed date. The result is YYYY-MM-DD, the stored format.
  batchDateToInputValue(batchDate) {
    if (!batchDate) return '';
    const datePart = String(batchDate).trim().split(/[T ]/)[0];
    const date = moment(datePart, ['YYYYMMDD', 'YYYY-MM-DD', 'DD/MM/YYYY'], true);
    return date.isValid() ? date.format('YYYY-MM-DD') : '';
  },
  fromNow(value){
    let date = getDate(value);
    return date.fromNow();
  },
  getDaysBetweenDates(startDate, endDate) {
    var now = startDate.clone(), dates = [];

    while (now.isSameOrBefore(endDate)) {
      dates.push(now.clone());
      now.add(1, 'days');
    }
    return dates;
  }
}

export default function install(Vue, locale="es", options={}) {
  if (options != null){
    moment.locale(locale, options);
  } else {
    moment.locale(locale);
  }

  installVueGlobal(Vue, '$dateUtils', dateUtils);
}